
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';

export default function EmailVerificationPage() {
  return (
    <div className="flex items-center justify-center min-h-screen px-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-center">Verify Your Email</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-center mb-6">Please check your email to verify your account</p>
          <div className="space-y-4">
            <p className="text-center text-muted-foreground">
              A verification link has been sent to your email address.
            </p>
          </div>
        </CardContent>
        <CardFooter className="flex justify-center">
          <Button asChild variant="link">
            <Link to="/login">Back to login</Link>
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
